import type { IPost } from "../../../../types/models/post.models.types";
import { usePutHttp } from "../../http.hook";

export interface IPostResponse {
  post: IPost;
}

export function usePostsApproveDraftEmphemeralHttp() {
  return usePutHttp<null, IPostResponse>({
    path: "/ephemeral/brand-dash/posts/:id/approve-draft",
  });
}
